


















































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { CommonApi } from "@/api/commonApi";
import { isLogin } from "@/utils/utils";
import router from "@/router";

@Component
export default class Header extends Vue {
  @Prop({ default: 0 }) private navIndex?: number;
  commonApi: CommonApi = new CommonApi();
  isLogin = false;
  searchKey = "";
  nickName: string | null = "";
  wxLoginUrl = `https://open.weixin.qq.com/connect/qrconnect?appid=wxda87ecd6150c5b3d&redirect_uri=${encodeURIComponent(
    process.env.VUE_APP_HOST_URL
  )}&response_type=code&scope=snsapi_login&state=STATE`;

  mounted() {
    this.isLogin = isLogin();
    if (!this.isLogin) {
      const code = this.$route.query["code"]?.toString();
      if (code != null && code != "") {
        this.commonApi.login(code).then((res) => {
          this.isLogin = true;
          this.nickName = res.data.customerName;
          sessionStorage.setItem("userId", res.data.customerId);
          sessionStorage.setItem("token", res.data.token);
          sessionStorage.setItem("nickName", res.data.customerName);
          sessionStorage.setItem("avaUrl", res.data.avaUrl);
          sessionStorage.setItem("gender", res.data.gender);
        });
      }
    } else {
      this.nickName = sessionStorage.getItem("nickName");
    }
  }

  search() {
    router.push({ path: "/newsSearchResult", query: { k: this.searchKey } });
  }
}
